/**
 * @name toBool
 * @description Utility function to convert a string that is loaded via Vite's import.meta.env to a boolean.
 * @param {string | undefined} value
 * @returns {boolean}
 * @example
 * ````typescript
 *  toBool('true'); // returns true
 *  toBool('1'); // returns true
 *  toBool('yes'); // returns true
 *  toBool('false'); // returns false
 *  toBool('0'); // returns false
 *  toBool('no'); // returns false
 *  toBool(undefined); // returns false
 *  toBool(''); // returns false
 *  toBool('maybe'); // returns false
 *  toBool('enabled'); // returns false
 * ````
 */
export const toBool = (value: string | undefined): boolean => {
  if (!value) {
    return false;
  }
  const normalizedValue = value.trim().toLowerCase();
  return normalizedValue === 'true' || normalizedValue === '1' || normalizedValue === 'yes';
};
